// import styled from 'styled-components';

// const Menu = styled.div`
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   position: absolute;
//   background: rgba(0, 0, 0, 0.7);
//   left: 0;
//   height: 100%;
//   max-height: calc(100vh - 75px);
//   width: ${(props) => (props.hidden ? '100%' : '400px')};
//   z-index: 97;
// `;

// Menu.Wrapper = styled.div`
//   flex: 1;
//   display: flex;
//   height: 100%;
// `;

// const Fixed = styled.div`
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   height: 100%;
//   width: 400px;
// `;

// export { Menu, Fixed };

import styled, { keyframes } from 'styled-components';

/* ===== Identidade visual (alinhada ao login / Header) =====
   Overlay escuro navy com leve blur; painel desliza ao abrir.
=========================================================== */

const slideIn = keyframes`
  from { transform: translateX(-12px); opacity: 0; }
  to   { transform: translateX(0); opacity: 1; }
`;

const Menu = styled.div`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  position: absolute;
  left: 0;
  height: 100%;
  max-height: calc(100vh - 75px);
  width: ${(props) => (props.hidden ? '100%' : '400px')};
  z-index: 97;

  background: rgba(6, 14, 26, 0.55);
  backdrop-filter: blur(4px);
`;

Menu.Wrapper = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  animation: ${slideIn} 0.28s cubic-bezier(0.22, 1, 0.36, 1) both;
`;

const Fixed = styled.div`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  height: 100%;
  width: 400px;
`;

export { Menu, Fixed };
